export default function ConsentBanner({ onAccept, onReject }) {
  return (
    <div className="elevated fixed bottom-4 left-4 right-4 z-40 rounded-2xl border border-brand-border bg-brand-surface p-4 md:left-auto md:max-w-md">
      <p className="text-sm text-brand-text">We use analytics cookies to improve calculator performance and content quality.</p>
      <div className="mt-3 flex gap-2">
        <button onClick={onAccept} className="rounded-xl bg-brand-accent px-3 py-2 text-sm font-semibold text-white">Accept</button>
        <button onClick={onReject} className="rounded-xl border border-brand-border bg-brand-surface px-3 py-2 text-sm font-semibold text-brand-text">Reject</button>
      </div>
    </div>
  );
}
